module.exports = __webpack_public_path__ + "img/top_menu13.00c857c9.png";